import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent } from '@/components/ui/card';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

export default function RecuperarPassword() {
  const [email, setEmail] = useState('');
  const [cargando, setCargando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error('Ingresa tu correo electronico'); return; }
    setCargando(true);
    try {
      await api.post('/auth/solicitar-recuperacion', { email: email.trim().toLowerCase() });
      setEnviado(true);
    } catch {
      toast.error('Error al enviar el correo. Intenta de nuevo.');
    } finally { setCargando(false); }
  };

  if (enviado) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
        <Card className="bg-slate-900/80 border-slate-800 max-w-md w-full">
          <CardContent className="p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-emerald-500/20 flex items-center justify-center mx-auto mb-5">
              <CheckCircle className="w-8 h-8 text-emerald-400" />
            </div>
            <h2 className="font-barlow text-2xl font-bold text-slate-50 mb-3">Correo Enviado</h2>
            <p className="text-slate-400 text-sm mb-2">
              Si <strong className="text-slate-200">{email}</strong> esta registrado, recibiras un enlace para restablecer tu contrasena.
            </p>
            <p className="text-slate-500 text-xs mb-6">Revisa tu bandeja de entrada y spam. El enlace expira en 1 hora.</p>
            <Link to="/login">
              <Button variant="outline" className="border-slate-700 text-slate-300 hover:bg-slate-800" data-testid="volver-login-btn">
                <ArrowLeft className="w-4 h-4 mr-2" /> Volver al login
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <Card className="bg-slate-900/80 border-slate-800 max-w-md w-full">
        <CardContent className="p-8">
          <div className="text-center mb-6">
            <div className="w-16 h-16 rounded-full bg-amber-500/20 flex items-center justify-center mx-auto mb-4">
              <Mail className="w-8 h-8 text-amber-500" />
            </div>
            <h2 className="font-barlow text-2xl font-bold text-slate-50">Recuperar Contrasena</h2>
            <p className="text-slate-400 text-sm mt-2">Ingresa tu correo y te enviaremos un enlace para restablecerla</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400">Correo electronico</Label>
              <Input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="tu@email.com" autoFocus
                className="bg-slate-950 border-slate-700 text-slate-200 focus:border-amber-500 mt-1"
                data-testid="recuperar-email-input" />
            </div>
            <Button type="submit" disabled={cargando}
              className="w-full bg-amber-500 hover:bg-amber-600 text-black font-bold rounded-sm h-11"
              data-testid="enviar-recuperacion-btn">
              {cargando ? 'Enviando...' : 'Enviar Enlace de Recuperacion'}
            </Button>
          </form>

          <div className="text-center mt-5">
            <Link to="/login" className="text-sm text-slate-500 hover:text-amber-500 transition-colors">
              <ArrowLeft className="w-3 h-3 inline mr-1" /> Volver al login
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
